import {
  useEffect,
  useLayoutEffect,
  useRef,
  EffectCallback,
  DependencyList,
} from 'react';

export const useUpdateEffect = (
  effect: EffectCallback,
  deps?: DependencyList,
) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    return effect();
  }, deps);
};

export const useLayoutUpdateEffect = (
  effect: EffectCallback,
  deps?: DependencyList,
) => {
  const isFirstRender = useRef(true);

  useLayoutEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    return effect();
  }, deps);
};
